var render = function render(){var _vm=this,_c=_vm._self._c;return _c('full-screen-modal',{attrs:{"show-close-button":false}},[_c('SignupLogin')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }